import { render, staticRenderFns } from "./CandidateName.vue?vue&type=template&id=047cbe04&"
import script from "./CandidateName.vue?vue&type=script&lang=js&"
export * from "./CandidateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports